import * as React from 'react';

type TabRefs = {
    [key: string]: {
        current: HTMLDivElement | null;
    };
};

type UseScrollToTabOptions = {
    tabRefs: TabRefs;
    scrollContainerRef:
        | {
              current: HTMLDivElement | null;
          }
        | null
        | undefined;
    stickyHeaderOffset?: number;
};

export function useScrollToTab(options: UseScrollToTabOptions) {
    const {tabRefs, scrollContainerRef, stickyHeaderOffset = 0} = options;

    const scrollToTab = React.useCallback(
        (tabId: string) => {
            const tabRef = tabRefs[tabId];
            const container = scrollContainerRef && scrollContainerRef.current;

            if (tabRef && tabRef.current && container) {
                const tabElement = tabRef.current;
                const containerRect = container.getBoundingClientRect();
                const tabRect = tabElement.getBoundingClientRect();

                // Calculate the scroll position to position the tab at the top of the container
                const scrollTop =
                    container.scrollTop + tabRect.top - containerRect.top - stickyHeaderOffset;

                container.scrollTo({
                    top: scrollTop,
                    behavior: 'smooth',
                    // @ts-expect-error
                    duration: 100,
                });
            }
        },
        [tabRefs, scrollContainerRef, stickyHeaderOffset]
    );

    return {scrollToTab};
}
